export const newsCategories = ['全部资讯', '业内动态', '影评', '幕后', '奖项', '片单'];

export const newsList = [
  {
    id: 'oscar-season-preview',
    title: '2026 颁奖季前瞻：五部最有冠军相的影片',
    subtitle: '从威尼斯到多伦多，今年的奖季格局已经初现轮廓',
    category: '奖项',
    date: '2026-10-17',
    author: '沈知微',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20cinema%20awards%20season%20editorial%20image%2C%20empty%20grand%20theatre%20with%20deep%20red%20velvet%20seats%20and%20a%20single%20warm%20spotlight%20on%20the%20stage%2C%20golden%20statue-like%20silhouette%20in%20the%20distance%2C%20deep%20navy%20shadows%2C%20cinematic%20atmosphere%2C%20no%20text&width=1200&height=720&seq=midnight-news-01&orientation=landscape',
    excerpt: '威尼斯与多伦多的口碑陆续解禁，今年的颁奖季比往年更早进入白热化。我们整理了五部目前呼声最高的作品，以及它们各自的胜负手。',
    content: [
      '如果说去年的颁奖季是流媒体的全面胜利，那么今年更像是一次院线的温和反攻。从八月底的威尼斯开始，几部原本并不被看好的中等成本剧情片连续拿下场刊高分，把整个奖季的节奏彻底打乱。',
      '目前呼声最高的五部作品中，有三部来自亚洲导演。它们在视听语言上并不炫技，却都以极为克制的叙事处理了相当私人的情感经验。这种“小声说话”的策略，恰好击中了近两年评委的口味变化。',
      '值得注意的是，技术类奖项的竞争比往年更激烈。《霓虹迷城》的美术与摄影几乎被所有前瞻榜单列为必进项，而《龙脊》的实景动作设计也被认为是近年少见的完成度。',
      '当然，奖季从来不是纯粹的艺术评判。发行策略、上映窗口、甚至一场恰到好处的映后问答，都可能改变最终结果。真正的悬念，大概要等到明年一月才会揭晓。',
      '在这之前，我们不妨先把这些电影看完。毕竟所有关于奖项的讨论，最终都要回到银幕上那两小时的光影里。',
    ],
  },
  {
    id: 'echoes-of-the-void-review',
    title: '《星际回声》影评：在宇宙尽头听见人的声音',
    subtitle: '一部关于“听见”的科幻片，也是一部关于“错过”的家庭片',
    category: '影评',
    date: '2026-10-14',
    author: '周迟',
    cover: 'https://readdy.ai/api/search-image?query=Lone%20astronaut%20seated%20inside%20a%20dim%20space%20station%20listening%20module%2C%20huge%20window%20showing%20a%20deep%20blue%20planet%2C%20warm%20orange%20instrument%20lights%20reflecting%20on%20the%20visor%2C%20quiet%20melancholic%20cinematic%20still%2C%20no%20text&width=1200&height=720&seq=midnight-news-02&orientation=landscape',
    excerpt: '《星际回声》最动人的地方不在于它拍出了多大的宇宙，而在于它把宇宙缩成了一间只有一个人的房间。',
    content: [
      '科幻片常常沉迷于尺度：星系、光年、文明兴衰。而《星际回声》一开始就放弃了这种炫目，把几乎全部篇幅留在一个不到二十平方米的监听舱里。主角的工作是听，听那些可能永远不会被回应的信号。',
      '影片最精妙的设计，是让那段来自太阳系边缘的信号，与主角童年的家庭录像在声波结构上完全一致。这个设定并不新鲜，但导演没有把它当成谜题来解开，而是让它慢慢渗进角色的日常，直到观众也分不清那是科学发现还是记忆幻觉。',
      '摄影指导显然很懂“少即是多”。全片几乎没有大幅度的运动镜头，大量画面依靠舱内仪表的暖橙色与舷窗外的深蓝形成对视。这种近乎静止的构图，反而让最后二十分钟的沉默拥有了巨大的重量。',
      '表演方面，顾南舟贡献了职业生涯最克制的一次演出。她没有哭，没有崩溃，只是在读出一段摇篮曲的歌词时，停顿了半秒。那半秒，比任何配乐都更像告别。',
      '如果要挑毛病，第三幕的解码过程略显冗长，个别科学解释的对白也带着一点课堂气。但这些瑕疵并不妨碍它成为今年最值得在深夜独自看完的一部电影。',
    ],
  },
  {
    id: 'midnight-box-office',
    title: '午夜档票房逆袭：小成本惊悚片如何撬动十亿市场',
    subtitle: '当大制作集体失手，观众开始为“两个小时的心跳”买单',
    category: '业内动态',
    date: '2026-10-11',
    author: '林一鸣',
    cover: 'https://readdy.ai/api/search-image?query=Cinema%20box%20office%20at%20night%2C%20glowing%20ticket%20counter%20and%20queues%20of%20silhouetted%20moviegoers%2C%20warm%20amber%20light%20spilling%20onto%20a%20dark%20street%2C%20deep%20navy%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=720&seq=midnight-news-03&orientation=landscape',
    excerpt: '过去三个月，午夜场次的平均上座率上涨了 38%。这不是一个偶然的档期现象，而是一次观众结构的悄然改变。',
    content: [
      '在行业普遍认为“观众正在离开影院”的这一年，午夜档交出了一份反常识的答卷。几部投资不足三千万的惊悚片，靠着极高的话题度和口碑扩散，把原本最冷门的时段变成了黄金场。',
      '一位院线经理告诉我们，午夜场的观众构成和白天完全不同：他们更年轻，更愿意为情绪价值付费，也更少在观影中途看手机。“他们要的不是合家欢，是两个小时彻底被拽进另一个世界的体验。”',
      '这类影片的共同点是成本控制极为极端：场景少、演员少、特效少，但在声音设计和悬念节奏上投入了不成比例的精力。观众离开影院后讨论的不是特效，而是结局到底该怎么理解。',
      '流媒体的反应也很快。多家平台已经开始采购这类影片的独家上线权，并尝试把“午夜场”做成一个固定的内容标签，用策展的方式打包推给用户。',
      '当然，逆袭的前提是内容真的合格。过去三个月同样有大量跟风之作在午夜档悄无声息地上映又下映——观众可以为一颗好心脏买单，但不会为同一颗心脏买第二次。',
    ],
  },
  {
    id: 'neon-labyrinth-art',
    title: '《霓虹迷城》美术揭秘：一座只存在于雨里的城市',
    subtitle: '专访美术指导何未：我们没有搭一座城，只搭了它的倒影',
    category: '幕后',
    date: '2026-10-08',
    author: '苏禾',
    cover: 'https://readdy.ai/api/search-image?query=Film%20set%20construction%20of%20a%20rainy%20neon%20city%20street%2C%20scaffolding%20and%20painted%20facades%2C%20warm%20orange%20practical%20lights%20and%20cool%20blue%20haze%2C%20crew%20silhouettes%2C%20behind%20the%20scenes%20cinematic%20photography%2C%20no%20text&width=1200&height=720&seq=midnight-news-04&orientation=landscape',
    excerpt: '整部电影有 68% 的镜头在下雨。这不是天气问题，而是一次精心计算的美术决策。',
    content: [
      '《霓虹迷城》里的城市没有白天。即便在设定上应该是正午，画面也永远隔着一层雨水、雾气或玻璃。美术指导何未说，这是他们最开始就定下的唯一铁律。',
      '“实景城市太具体了，观众会认出它在哪。我们要的是一座记不住名字的城市。”为了达到这个效果，团队把主要场景拆成三段：地面上是真实的老街，中景是搭建的招牌与连廊，远景则全部交给绘景和数字延长。',
      '雨是另一个主角。全片 68% 的镜头有雨，但每一场的雨都不一样：追车戏是斜雨，室内是顺着玻璃流下的水痕，而结尾那场则是几乎静止的细密水雾。不同的雨对应角色不同的认知状态。',
      '色彩上，影片刻意避开了常见的青橙对比，改用深蓝与暖红的双色体系。何未解释，蓝负责空间的深度，红负责人的欲望，“当一个人被红光照亮，他就开始不诚实了”。',
      '最费工的其实不是大场面，而是一条只有四十秒的巷道。为了让霓虹在积水里形成完整的倒影，剧组在地面铺了一层特制的黑色树脂，再手工做出数百个微小的高低差。这个镜头最终在成片里出现了四次。',
    ],
  },
  {
    id: 'october-watchlist',
    title: '十月片单：12 部值得留给深夜的电影',
    subtitle: '把它们留到凌晨一点，关灯，戴上耳机',
    category: '片单',
    date: '2026-10-05',
    author: '午夜编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20dark%20living%20room%20at%20midnight%20with%20a%20projector%20beam%20crossing%20the%20room%2C%20stack%20of%20film%20canisters%20and%20a%20cup%20on%20a%20low%20table%2C%20warm%20amber%20lamp%20against%20deep%20blue%20shadows%2C%20cinematic%20interior%20editorial%20photograph%2C%20no%20text&width=1200&height=720&seq=midnight-news-05&orientation=landscape',
    excerpt: '深夜看电影是一件很私人的事。这份片单没有爆米花大片，只有那些适合一个人看完、然后安静坐一会儿的作品。',
    content: [
      '我们筛选片单的标准很简单：它必须在深夜两点依然抓得住你，而且看完之后你不想立刻打开下一部。',
      '第一批是“慢”的电影。《父亲的胶片》《最后一场雪》《山海之间》都属于这一类。它们的节奏近乎固执，但每一次沉默都在积累情绪，直到某个日常动作突然让你溃不成军。',
      '第二批是“紧”的电影。《深海列车》《沉默证词》《极昼计划》适合想要被攥住喉咙的夜晚。它们不靠血浆，靠的是空间、声音和一句说了一半的台词。',
      '第三批留给浪漫。《一秒钟的永恒》《雨巷来信》《夏日放映厅》讲的都是时间不够用的爱情。深夜里看这些，会比白天更容易相信其中的谎言。',
      '最后三部是给还不想睡的人：《霓虹迷城》《星际回声》《时空修补匠》。它们都很长，也都很安静，适合把手机调成静音，让屏幕成为房间里唯一的光源。',
    ],
  },
  {
    id: 'dragon-ridge-action',
    title: '《龙脊》动作设计：三个镜头，拍了四十七天',
    subtitle: '没有威亚，没有替身，只有一个剧组在海拔三千米等风停',
    category: '幕后',
    date: '2026-09-29',
    author: '郑野',
    cover: 'https://readdy.ai/api/search-image?query=Martial%20arts%20film%20crew%20on%20a%20misty%20mountain%20ridge%20at%20dawn%2C%20stunt%20performers%20rehearsing%20with%20wooden%20swords%2C%20camera%20rig%20on%20a%20narrow%20path%2C%20deep%20blue%20fog%20and%20warm%20sunrise%20light%2C%20cinematic%20behind%20the%20scenes%2C%20no%20text&width=1200&height=720&seq=midnight-news-06&orientation=landscape',
    excerpt: '一场三分钟的山脊对决，最终在成片里只保留了三个镜头。而这三个镜头，剧组拍了整整四十七天。',
    content: [
      '《龙脊》最被讨论的那场戏，发生在海拔三千米的一处风口。剧本上只有一句话：两人在山脊相遇，一人坠崖。',
      '动作指导徐北坚持不用绿幕。他带着十二个人的小队在山里住了两个月，每天等两个时间窗口：日出后二十分钟和日落前十五分钟。风超过五级就无法拍摄，而那里一年有三分之二的时间在刮风。',
      '真正的困难不是动作，而是 footing。山脊宽度不足八十厘米，演员要在上面完成转身、格挡和一次近乎失控的后撤。所有威亚都被藏在岩石背面，只在最危险的半秒介入。',
      '最终成片里，这场戏只有三个镜头：一个长焦的接近，一个手持的近身缠斗，以及一个静止了很久的空镜。第四个镜头被剪掉了，因为导演觉得“人已经掉下去了，山不需要再解释”。',
      '“观众记住的从来不是我们拍了多少，”徐北说，“是他们相信那一刻真的有人站在悬崖边上。”',
    ],
  },
  {
    id: 'streaming-cinema-handshake',
    title: '流媒体与院线的第三次握手',
    subtitle: '窗口期缩短之后，谁在真正获益？',
    category: '业内动态',
    date: '2026-09-24',
    author: '林一鸣',
    cover: 'https://readdy.ai/api/search-image?query=Split%20concept%20image%20of%20a%20cinema%20screen%20and%20a%20glowing%20streaming%20interface%20merging%20in%20dark%20space%2C%20warm%20amber%20projector%20light%20meeting%20cool%20blue%20digital%20glow%2C%20minimal%20cinematic%20editorial%20visual%2C%20no%20text&width=1200&height=720&seq=midnight-news-07&orientation=landscape',
    excerpt: '从 90 天到 30 天，再到同步上线。窗口期的每一次缩短，都会重新分配一遍行业的利润与话语权。',
    content: [
      '窗口期曾经是院线最坚固的一道护城河。如今这道墙正在被反复试探：先是缩短到 45 天，再是 30 天，部分中小成本影片干脆选择了院网同步。',
      '对观众来说，这似乎是纯粹的好事。但对制作方而言，选择意味着押注：院线能带来话题和长尾，流媒体能带来确定的现金流。两者很难同时最大化。',
      '有趣的是，今年几部选择长窗口期的影片反而表现更好。它们在院线维持了六周以上的热度，上线流媒体时又获得了一轮新的讨论。这说明“窗口期”本身并不是问题，问题是有没有足够的理由让观众走进影院。',
      '院线方面也在改变策略。越来越多的影院开始做主题策展、导演映后、深夜专场，把“看电影”重新包装成一件有仪式感的事，而不是单纯的 content delivery。',
      '这场握手大概还会持续很久。但可以确定的是，最终的裁判仍然是内容本身——一部不值得在大银幕看的电影，放到哪里都不会变得值得。',
    ],
  },
  {
    id: 'the-last-snow-review',
    title: '《最后一场雪》：把告别拍成一场漫长的呼吸',
    subtitle: '它没有刻意催泪，只是把生活原样放在你面前',
    category: '影评',
    date: '2026-09-18',
    author: '周迟',
    cover: 'https://readdy.ai/api/search-image?query=Elderly%20man%20walking%20alone%20on%20a%20snowy%20village%20road%20at%20blue%20hour%2C%20warm%20amber%20window%20lights%20in%20the%20distance%2C%20thin%20smoke%20from%20chimneys%2C%20quiet%20melancholic%20cinematic%20still%2C%20no%20text&width=1200&height=720&seq=midnight-news-08&orientation=landscape',
    excerpt: '《最后一场雪》几乎不提供情绪出口。它只是让雪一直下，让老人一直走，让观众自己决定什么时候难过。',
    content: [
      '这部片子上映时并没有太多声势，靠着一轮又一轮的口碑慢慢被看见。三年过去，它依然是很多人心里“最不敢看第二遍”的那一部。',
      '导演梁守一的处理方式近乎冷酷：全片没有一场真正的哭戏，最重要的告别发生在画面之外的厨房里，观众只听见水壶烧开的声音。',
      '这种克制反而制造了巨大的后坐力。当孙女终于在雪地里蹲下来系鞋带，镜头没有推近，也没有配乐，只是安静地停在那里。那一刻，影院里能听见很多人在吸鼻子。',
      '美术和摄影同样值得称道。东北的冬天被拍得既辽阔又封闭，白到发蓝的雪原与室内昏黄的灯形成唯一的温度差。人在其中显得很小，但并不孤独。',
      '如果要说它教会了什么，大概是：告别不需要仪式，它只是某一天你突然发现，那个总在门口等你的人不在了。',
    ],
  },
  {
    id: 'new-director-wave',
    title: '新导演浪潮：他们不再讲宏大叙事',
    subtitle: '过去两年最值得关注的八位华语新导演',
    category: '业内动态',
    date: '2026-09-10',
    author: '沈知微',
    cover: 'https://readdy.ai/api/search-image?query=Young%20film%20director%20silhouette%20framed%20by%20a%20projector%20beam%20in%20a%20small%20screening%20room%2C%20warm%20amber%20light%20and%20deep%20blue%20shadows%2C%20film%20canisters%20on%20the%20floor%2C%20quiet%20documentary%20style%20cinematic%20portrait%2C%20no%20text&width=1200&height=720&seq=midnight-news-09&orientation=landscape',
    excerpt: '他们不约而同地放弃了史诗，转向厨房、出租屋、深夜便利店和一张旧沙发。',
    content: [
      '如果要用一个词概括这两年涌现的华语新导演，大概是“向内”。他们的处女作很少涉及历史、战争或时代命题，更多关于一个具体的人如何度过一个具体的下午。',
      '这批创作者大多出生于九十年代，成长于互联网环境。他们对宏大叙事天然警惕，却对细节有近乎偏执的兴趣：一碗面的热气、空调外机的滴水声、凌晨三点的便利店灯光。',
      '制作方式也随之改变。小团队、自然光、非职业演员成为常态。有的影片全程只有三个工作人员，摄影师同时负责录音和场记。',
      '这种轻量化的拍摄并不意味着粗糙。恰恰相反，正是因为资源有限，他们必须在每一场戏里想清楚“为什么需要这个镜头”。',
      '当然，向内并不等于安全。当所有年轻导演都在拍个人的失落时，如何避免同质化，会是下一阶段真正的考验。',
    ],
  },
];